import { CustomElement } from "../../../core/CustomElement";
import SelectItem from "../../../core/interfaces/SelectItem";

import ko from "knockout";

export default class SelectSingleVM {
  $customElement: CustomElement;
  label: KnockoutObservable<string>;
  fieldWidth: KnockoutObservable<string>;
  fieldHeight: KnockoutObservable<string>;
  fieldLeft: KnockoutObservable<string>;
  minLength: KnockoutObservable<number>;
  disabled: KnockoutObservable<boolean>;
  options: KnockoutObservableArray<SelectItem>;
  filteredOptions: KnockoutObservableArray<SelectItem>;
  rawValue: KnockoutObservable<string>;
  rawValueChange: KnockoutComputed<string>;
  rawValueChangeSubscriptionId: KnockoutSubscription;
  focus: KnockoutObservable<boolean>;
  focusChange: KnockoutComputed<boolean>;
  focusChangeSubscriptionId: KnockoutSubscription;
  displayList: KnockoutObservable<boolean>;
  value: KnockoutObservable<SelectItem>;
  displayLoader: KnockoutObservable<boolean>;
  selected: (item: SelectItem) => KnockoutComputed<boolean>;
  private oldValue: SelectItem;
  placeholder: KnockoutObservable<string>;
  displayAsTabs: KnockoutObservable<boolean>;

  constructor($customElement: CustomElement) {
    this.$customElement = $customElement;
    this.displayAsTabs = ko.observable(false);
    this.label = ko.observable();
    this.fieldWidth = ko.observable();
    this.fieldHeight = ko.observable();
    this.fieldLeft = ko.observable();
    this.minLength = ko.observable(0);
    this.disabled = ko.observable();
    this.options = ko.observableArray();
    this.filteredOptions = ko.observableArray();
    this.rawValue = ko.observable("");
    this.rawValueChange = ko.pureComputed(this.rawValue);
    this.rawValueChangeSubscriptionId = this.rawValueChange.subscribe(
      (val: string) => {
        if (
          val.length >= 0 &&
          val !== this.placeholder() &&
          val !== this.value().name
        ) {
          this.showOptionsList();
        } else {
          this.hideOptionsList();
        }
      },
      this
    );
    this.focus = ko.observable(false);
    this.focusChange = ko.pureComputed(this.focus);
    this.focusChangeSubscriptionId = this.focusChange.subscribe(
      (val: boolean) => {
        if (val && !this.disabled()) {
          this.showOptionsList();
        } else {
          this.hideOptionsList();
        }
      },
      this
    );
    this.displayList = ko.observable(false);
    this.value = ko.observable({ id: -1, name: "" });
    this.displayLoader = ko.observable(false);
    this.selected = function (item: SelectItem) {
      return ko.computed({
        read: () => {
          return item.id === this.value().id;
        },
      });
    };
    this.placeholder = ko.observable();
    this.placeholder.subscribe((newValue: string) => {
      if (newValue.trim() !== "") {
        this.rawValue(newValue);
      }
    });
    this.displayAsTabs.subscribe((newValue: boolean) => {
      if (newValue) {
        this.showOptionsList();
      }
    });
    ko.computed(() => {
      this.displayAsTabs() ? this.showOptionsList() : "";
    });
  }

  onRawValueChange(
    callback: ((viewModel: this, val: string) => void) | null,
    timeout: number | null
  ): void {
    this.rawValueChangeSubscriptionId.dispose();
    if (timeout) {
      this.rawValueChange.extend({
        rateLimit: { method: "notifyWhenChangesStop", timeout: timeout },
      });
    }
    if (callback) {
      this.rawValueChange.subscribe((val: string) => {
        callback(this, val);
      }, this);
    }
  }

  onFocusChange(
    callback: ((viewModel: this, val: boolean) => void) | null
  ): void {
    this.focusChangeSubscriptionId.dispose();
    if (callback) {
      this.focusChange.subscribe((val: boolean) => {
        callback(this, val);
      }, this);
    }
  }

  getFocus(data: this, event: FocusEvent): void {
    if (
      event.target instanceof HTMLElement &&
      (<HTMLElement>event.target).classList.contains("container")
    ) {
      this.$customElement.shadowDom.getElementById("input").focus();
    }
    this.focus(true);
  }

  loseFocus(data: this, event: FocusEvent): void {
    if (
      event.target instanceof HTMLInputElement &&
      (<HTMLInputElement>event.target).id === "input"
    ) {
      if (
        this.value().name !== this.rawValue() &&
        this.rawValue() !== this.placeholder()
      ) {
        this.rawValue(this.value().name);
      }
      this.hideOptionsList();
      this.focus(false);
    }
  }

  showOptionsList(): void {
    const $component = <HTMLElement>(
      (<CustomElement>(
        this.$customElement.shadowDom.querySelector("ccc-field")
      )).shadowDom.querySelector(".component")
    );
    this.fieldWidth($component.getBoundingClientRect().width + "px");
    this.fieldHeight($component.offsetHeight - 2 + "px");
    this.fieldLeft("-1px");
    this.filteredOptions(this.options());
    if (
      this.rawValue() !== this.value().name &&
      this.rawValue() !== this.placeholder()
    ) {
      this.filterOptions();
    }
    this.displayList(true);
  }

  hideOptionsList(): void {
    this.displayList(false);
  }

  filterOptions(): void {
    if (this.options() || this.options.length > 0) {
      this.filteredOptions(
        this.filteredOptions().filter(
          (option: SelectItem) =>
            option.name.toLowerCase().indexOf(this.rawValue().toLowerCase()) >
            -1
        )
      );
    }
  }

  selectItem(itemToAdd: SelectItem): void {
    this.hideOptionsList();
    this.value(itemToAdd);
    this.rawValue(itemToAdd.name);
    this.$customElement.shadowDom.getElementById("input").blur();
  }

  onItemSelect(callback: (value: SelectItem) => void): void {
    this.value.subscribe(
      (oldValue) => {
        this.oldValue = oldValue;
      },
      null,
      "beforeChange"
    );
    this.value.subscribe((newValue) => {
      if (this.oldValue !== newValue) {
        callback(newValue);
      }
    });
  }

  displayPlaceholder(): void {
    this.rawValue(this.placeholder());
  }
}
